// extracted by mini-css-extract-plugin
module.exports = {"container":"catPanel_container__GkkAg","box":"catPanel_box__2fhTg","textBox":"catPanel_textBox__10Nfm","categoryName":"catPanel_categoryName__1Qqev"};